import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
// import Close from 'src/assets/images/CloseProduct.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import React, { useState, useRef } from 'react';
import ScanditBarcodeScanner from 'scandit-sdk-react';
import { Barcode, ScanSettings, BarcodePicker } from 'scandit-sdk';
// import * as ScanditSDK from 'scandit-sdk';
import { useSelector, useDispatch } from 'react-redux';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutlineWhite.svg';
import ScanditLogo from 'src/assets/images/scandit-vector-logo.svg';
import {
    Content,
    // Icon,
    Header,
    Container,
    ActionButton,
    HeaderTitle,
    MessageContainer,
    Msg,
    CameraScan,
    TroubleContainer,
    SetAddedSuccessDiv,
    ShowMsg,
    SpinnerDiv,
} from './index.styled';
import {
    createReceiveSets,
    getBarcodeReceiveSets,
    resetBarcodeDetails,
    resetCreateReceiveSets,
} from '../../redux/actions';
import NotAbleToReceiveSetsErrorMessage from './NotAbleToReceiveSetsErrorMessage';
import {
    getBarcodeItems,
    resetBarcodeDetails as clearBarcodeDetails,
    successMessageCamera,
} from 'src/common/barCodeScannerRedux/actions/actionCreators';

import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@material-ui/core';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { logErrorToConsole } from 'src/utils/util.js';

// Repeat scans of the same barcode inside this window are ignored.
const DUPLICATE_SCAN_LOCKOUT_MS = 3000;
const SCAN_AREA = { x: 0.2, y: 0.26, width: 0.6, height: 0.2 };

const ScanBardCodePopUp = ({
    scanBarCode,
    setScanBarCode,
    accountId,
    territoryId,
    counter,
    setCounter,
    counterMessage,
    setCounterMessage,
    isFromScannerBarcode,
    addItemChange,
    isConsignment,
}) => {
    // Select Scandit license key based on hostname
    // eslint-disable-next-line no-undef
    const getScanditLicenseKey = () => {
        const hostname = window.location.hostname;
        // Check if URL contains 'ous' (e.g., test.mycase.ous.medtronic.com)
        if (hostname.includes('.ous.') && process.env.SCANDIT_LICENSE_KEY_OUS) {
            return process.env.SCANDIT_LICENSE_KEY_OUS;
        }else if(hostname.includes('.us.') && process.env.SCANDIT_LICENSE_KEY_US) {
            return process.env.SCANDIT_LICENSE_KEY_US;
        }
        return process.env.SCANDIT_LICENSE_KEY;
    };
    
    const [licenseKey] = useState(getScanditLicenseKey());
    const winWidth = window.innerWidth;
    const isIpadPro = useMediaQuery('(min-width: 1024px) and (max-width: 1366px) and (orientation: landscape), (min-width: 834px) and (max-width: 1194px) and (orientation: portrait)');

    // const [showNotificationPopup, setShowNotificationPoup] = useState(false);
    const [
        showNotAbleToReceiveSetsErrorMessage,
        setShowNotAbleToReceiveSetsErrorMessage,
    ] = useState(false);
    const dispatch = useDispatch();
    const [smShow, setSmShow] = useState(false);
    const [, setStop] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showAdditionalSet, setShowAdditionalSet] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [barcodeNumber, setBarcodeNumber] = useState('');
    const [dChainCrossPlantStatus, setDChainCrossPlantStatus] = useState(false);
    const [scannerReady, setScannerReady] = useState(false);
    const [cameraActive, setCameraActive] = useState(false);
    const [videoReady, setVideoReady] = useState(false);
    const processedValidationRef = useRef(null);
    const lastScanRef = useRef({ barcode: null, timestamp: 0 });
    const { t } = useTranslation();
    // localStorage.clear();
    const barcodeDetails = useSelector(
        (state) => state.receiveSetsListDataReducer.barcodeDetails
    );
    const isBarcodeLoading = useSelector(
        (state) => state.receiveSetsListDataReducer.isBarcodeLoading
    );

    const receiveSetsListData = useSelector(
        (state) => state.receiveSetsListDataReducer.receiveSetsListData
    );
    const validatedData = useSelector(
        (state) => state.createReceiveSetsReducer.createReceiveSets
    );
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );
    const productDetails = useSelector(
        (state) => state?.receiveSetsListDataReducer?.productDetails
    );

    const [invalidBarcode, setInvalidBarcode] = useState(false);
    
    // Handle scanner ready state and camera activation
    useEffectWithErrorLogging(() => {
        if (scannerReady && scanBarCode && !cameraActive) {
            // Small delay to ensure iOS WebRTC is ready
            const activationTimer = setTimeout(() => {
                setCameraActive(true);
            }, 200);
            
            return () => clearTimeout(activationTimer);
        } else if (!scanBarCode && cameraActive) {
            setCameraActive(false);
        }
    }, [scannerReady, scanBarCode, cameraActive]);
    
    // Fallback: Force camera activation if SDK doesn't initialize within 3 seconds
    useEffectWithErrorLogging(() => {
        if (scanBarCode && !scannerReady && !cameraActive) {
            const fallbackTimer = setTimeout(() => {
                if (!scannerReady) {
                    setScannerReady(true);
                }
            }, 3000);
            
            return () => clearTimeout(fallbackTimer);
        }
    }, [scanBarCode, scannerReady, cameraActive]);
    
    // Wait for video stream to be ready after camera activation
    useEffectWithErrorLogging(() => {
        if (cameraActive && scannerReady) {
            // Give video stream time to start rendering (Safari needs more time)
            const videoTimer = setTimeout(() => {
                setVideoReady(true);
            }, 1500); // 1500ms for Safari compatibility
            
            return () => clearTimeout(videoTimer);
        } else if (!cameraActive) {
            setVideoReady(false);
        }
    }, [cameraActive, scannerReady]);
    
    const getScanSettings = () => {
        return new ScanSettings({
            enabledSymbologies: [
                Barcode.Symbology.CODE128,
                Barcode.Symbology.QR,
                Barcode.Symbology.AZTEC,
                Barcode.Symbology.DATA_MATRIX,
                // Barcode.Symbology.GS1_DATABAR,
                // Barcode.Symbology.GS1_DATABAR_EXPANDED,
                // Barcode.Symbology.GS1_DATABAR_LIMITED,
            ],
            codeDuplicateFilter: 4000,
            searchArea: SCAN_AREA,
            // codeDuplicateFilter: 99000,
            // searchArea: {
            //     left: 0,
            //     top: 0,
            //     width: 1,
            //     height: 1,
            // },
            // wideArea: {
            //     left: 0,
            //     top: 0.45,
            //     width: 0.5,
            //     height: 0.5,
            // },
            // setActiveScanningArea:
            // [ScanSettings.ORIENTATION_PORTRAIT, new RectF(0.0f, 0.45f, 1.0f, 0.55f)]
        });
    };

    // BarcodePicker.applyScanSettings.settings.setActiveScanningArea.ORIENTATION_PORTRAIT, new RectF(0.0f, 0.45f, 1.0f, 0.55f)
    //  BarcodePicker.applyScanSettings.
    //      ScanSettings settings = ScanSettings.create();
    //  settings.setActiveScanningArea(ScanSettings.ORIENTATION_PORTRAIT, new RectF(0.0f, 0.45f, 1.0f, 0.55f));
    // BarcodePicker.applyScanSettings(getScanSettings);

    // let videoElement = '';
    // useEffectWithErrorLogging(() => {
    //     videoElement = document.getElementById('video');

    //     let loading = true;
    //     setTimeout(() => {
    //         console.log('videoElement', videoElement);
    //         loading = false;
    //     }, 3000);
    //     if (!loading) {
    //         console.log('video loaded ');
    //     }
    // }, []);
    // const closeNotificationPopup = () => {
    //     dispatch(resetCreateReceiveSets());
    //     dispatch(resetBarcodeDetails());
    // };

    const closeTab = () => {
        // Set closing flag to prevent loader from showing during cleanup
        try {
            // Reset all states immediately
            setCameraActive(false);
            setScannerReady(false);
            setVideoReady(false);
            stopScanning();
            
            if (showSuccessMessage && scanBarCode) {
                dispatch(successMessageCamera(true));
            }
            dispatch(resetCreateReceiveSets());
            dispatch(resetBarcodeDetails());
            dispatch(clearBarcodeDetails());
            setScanBarCode(false);
            localStorage.setItem('isManual', false);
            setCounter(0);
            processedValidationRef.current = null; // Reset guard when closing scanner
            lastScanRef.current = { barcode: null, timestamp: 0 };
            localStorage.removeItem('createReceiveSetError');
        } catch (error) {
            logErrorToConsole(error);
        }
    };
    const stopScanning = () => {
        setSmShow(false);
        setStop(true);
        setCameraActive(false);
    };
    
    const handleScannerReady = () => {
        setScannerReady(true);
    };
    
    const handleScannerError = (error) => {
        console.error('Scandit SDK error:', error);
        logErrorToConsole(error);
    };

    // useEffectWithErrorLogging(() => {
    //     if (
    //         validatedData.statusCode != '10734' &&
    //         barcodeDetails.statusCode != '11613'
    //     ) {
    //         setCounter(counter + 1);
    //     }
    // }, [barcodeDetails, validatedData]);

    const barcodeData = useSelector(
        (state) => state.BarCodeScannerReducer.barcodeDetails
    );

    const isScannerBarcodeLoading = useSelector(
        (state) => state.BarCodeScannerReducer.isBarcodeLoading
    );

    useEffectWithErrorLogging(() => {
        if (
            barcodeData.statusCode == '11920' ||
            barcodeData.statusCode == '11921'
        ) {
            setInvalidBarcode(true);
            setDChainCrossPlantStatus(false);
            setShowNotAbleToReceiveSetsErrorMessage(false);
        } else if (barcodeData.statusCode == '10001' && isFromScannerBarcode) {
            setInvalidBarcode(false);
            setDChainCrossPlantStatus(false);
            setShowAdditionalSet(true);
            setErrorMessage('');
            setCounter(prev => {
                return prev + 1;
            });
            // setCounterMessage(counterMessage + 1);
            setShowSuccessMessage(true);
            if (barcodeData?.productDetails?.cfn) {
                addItemChange(barcodeData?.productDetails?.cfn, true);
            }
        }
        // else if (barcodeData.statusCode == '11921') {
        //     setDChainCrossPlantStatus(true);
        //     setInvalidBarcode(false);
        //     setShowNotAbleToReceiveSetsErrorMessage(false);
        // }
    }, [barcodeData]);

    useEffectWithErrorLogging(() => {
        if (barcodeDetails.statusCode === '11613') {
            setInvalidBarcode(true);
            setDChainCrossPlantStatus(false);
            setShowNotAbleToReceiveSetsErrorMessage(false);
        } else if (barcodeDetails.statusCode === '10001') {
            setInvalidBarcode(false);
            setDChainCrossPlantStatus(false);
            let newArray = [];
            let newObj = [];
            newObj = [
                {
                    setNo: barcodeDetails?.setNumber,
                    batchNo: barcodeDetails?.batchNumber,
                    accountCode: barcodeDetails?.accountCode,
                    accountName: barcodeDetails?.accountName,
                    isBarCode: true,
                    territoryId: territoryId,
                    description: barcodeDetails?.description,
                    barcode: barcodeNumber,
                    isFromBarcode: true,
                },
            ];

            const isFound = receiveSetsListData?.some((element) => {
                if (
                    element.batchNo == barcodeDetails.batchNumber &&
                    element.setNo === barcodeDetails.setNumber
                ) {
                    return true;
                }
            });
            if (isFound === true) {
                setErrorMessage('DuplicateScan');
                setShowNotAbleToReceiveSetsErrorMessage(false);
                setShowSuccessMessage(false);
                // Don't call API for duplicate scans
                return;
            } else {
                setShowAdditionalSet(true);
                setErrorMessage('');
                newArray = [...receiveSetsListData, ...newObj];
            }
            let setsPayload = [
                {
                    batchNo: barcodeDetails.batchNumber,
                    isBarCode: true,
                    setNo: barcodeDetails.setNumber,
                },
            ];

            const payload = {
                accountId: accountId.accountId,
                sets: setsPayload,
                territoryId: territoryId,
                isSubmit: false,
                dataList: newArray,
                isFromBarcode: true,
                accountName: accountId?.accountName,
            };
            dispatch(createReceiveSets(payload));
        }
    }, [barcodeDetails]);

    useEffectWithErrorLogging(() => {
        
        // Guard: Prevent processing the same validation result twice
        const validationKey = (validatedData && barcodeNumber) ? `${barcodeNumber}-${validatedData?.statusCode}` : null;
        
        if (validationKey && processedValidationRef.current === validationKey) {
            return;
        }
        
        if (
            validatedData?.statusCode === '10734' ||
            validatedData?.statusCode === '10830'
        ) {
            setInvalidBarcode(false);
            setDChainCrossPlantStatus(false);
            setShowNotAbleToReceiveSetsErrorMessage(true);
            setShowAdditionalSet(true);
            if (validationKey) {
                processedValidationRef.current = validationKey;
            }
        } else if (
            validatedData?.statusCode === '11617' &&
            !invalidBarcode &&
            !dChainCrossPlantStatus &&
            errorMessage != 'DuplicateScan'
        ) {
            setShowNotAbleToReceiveSetsErrorMessage(false);
            setCounter(prev => {
                return prev + 1;
            });
            setCounterMessage(prev => prev + 1);
            setShowSuccessMessage(true);
            setShowAdditionalSet(true);
            if (validationKey) {
                processedValidationRef.current = validationKey;
            }
        } else if (
            validatedData?.statusCode === '11911' &&
            validatedData?.isFromScanner
        ) {
            setDChainCrossPlantStatus(true);
            setInvalidBarcode(false);
            setShowNotAbleToReceiveSetsErrorMessage(false);
            if (validationKey) {
                processedValidationRef.current = validationKey;
            }
        }
        // setTimeout(() => setShowSuccessMessage(false), 4000);
    }, [validatedData]);

    useEffectWithErrorLogging(() => {
        if (
            invalidBarcode ||
            errorMessage === 'DuplicateScan' ||
            showNotAbleToReceiveSetsErrorMessage
        ) {
            const timer = setTimeout(() => {
                try {
                setInvalidBarcode(false);
                setErrorMessage('');
                setShowNotAbleToReceiveSetsErrorMessage(false);
                 } catch (error) {
                    logErrorToConsole(error);
                }
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [invalidBarcode, errorMessage, showNotAbleToReceiveSetsErrorMessage]);

    const callAPI = (result) => {
        const scannedBarcode = result?.trim();

        // Item scanning (usage/billing/bundle) has no duplicate detection of its
        // own, so ignore repeat scans of the same barcode within the lockout
        // window. A different barcode is always processed immediately. Receive
        // Sets is excluded because it reports duplicates through its own flow.
        if (isFromScannerBarcode && scannedBarcode) {
            const now = Date.now();
            if (
                lastScanRef.current.barcode === scannedBarcode &&
                now - lastScanRef.current.timestamp < DUPLICATE_SCAN_LOCKOUT_MS
            ) {
                return;
            }
            lastScanRef.current = { barcode: scannedBarcode, timestamp: now };
        }

        setBarcodeNumber(result);
        setScanBarCode(true);
        if (result) {
            // Reset processed validation key for every new scan so messages can
            // be shown again on subsequent scans (including same barcode/status).
            processedValidationRef.current = null;

            // Reset all message states before starting new scan
            setShowSuccessMessage(false);
            setShowAdditionalSet(false);
            setSmShow(true);
            setInvalidBarcode(false);
            setErrorMessage('');
            setShowNotAbleToReceiveSetsErrorMessage(false);
            setDChainCrossPlantStatus(false);
            if (isFromScannerBarcode) {
                if (isConsignment) {
                    dispatch(
                        getBarcodeItems({
                            barcode: result?.trim(),
                            orderType: 'KE',
                            externalScanner: 'true',
                        })
                    );
                } else {
                    dispatch(
                        getBarcodeItems({
                            barcode: result?.trim(),
                            orderType: 'ZLC',
                            externalScanner: 'true',
                        })
                    );
                }
            } else {
                dispatch(
                    getBarcodeReceiveSets({
                        barcode: result?.trim(),
                        accountId: accountId,
                        territoryId: territoryId,
                        isFromScanner: true,
                    })
                );
            }
        }
    };

    return (
        <>
            <ModalDialog
                modalHeight={'80vh'}
                modalWidth={isIpadPro ? '70%':'50%'}
                zIndex={'10000'}
                padding="15px 10px 4px 10px"
                marginTop="6.75rem"
                handleClose={() => closeTab()}
            >
                <Container>
                    <Header>
                        <HeaderTitle>
                            {t(
                                'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.popUpMsg'
                            )}
                        </HeaderTitle>
                        {/* <Icon
                            id="scan-barcode-popup-close-icon"
                            style={{ marginBottom: '12px' }}
                            path={Close}
                            onClick={() => {
                                closeTab();
                            }}
                        /> */}
                    </Header>
                    <Content>
                        {' '}
                        <div className="videobox">
                            <SetAddedSuccessDiv
                                className={`${
                                    smShow &&
                                    errorMessage != 'DuplicateScan' &&
                                    !invalidBarcode &&
                                    !dChainCrossPlantStatus &&
                                    !showNotAbleToReceiveSetsErrorMessage &&
                                    counter != 0 &&
                                    showSuccessMessage
                                        ? 'shape-qr-found'
                                        : showAdditionalSet &&
                                          counter != 0 &&
                                          smShow
                                        ? 'additional-set'
                                        : ''
                                }`}
                            >
                                {smShow && (
                                    <>
                                        {errorMessage != 'DuplicateScan' &&
                                            !invalidBarcode &&
                                            !dChainCrossPlantStatus &&
                                            !showNotAbleToReceiveSetsErrorMessage &&
                                            counter != 0 &&
                                            showSuccessMessage && (
                                                <Msg>
                                                    {' '}
                                                    {counter == 1 ? (
                                                        <>
                                                            {counter}{' '}
                                                            {isFromScannerBarcode
                                                                ? t(
                                                                      'common.itemLowerCaseLabel'
                                                                  )
                                                                : t(
                                                                      'common.setLowerCaseLabel'
                                                                  )}{' '}
                                                            {t(
                                                                'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg14'
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {counter}{' '}
                                                            {isFromScannerBarcode
                                                                ? t(
                                                                      'common.itemsLowerCaseLabel'
                                                                  )
                                                                : t(
                                                                      'common.setsLowerCaseLabel'
                                                                  )}{' '}
                                                            {t(
                                                                'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg14'
                                                            )}
                                                        </>
                                                    )}
                                                </Msg>
                                            )}
                                    </>
                                )}
                                {showAdditionalSet && counter != 0 ? (
                                    isLanguageChanged ? (
                                        <Msg isRegular={true}>
                                            {t(
                                                'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg20'
                                            )}
                                        </Msg>
                                    ) : (
                                        <Msg isRegular={true}>
                                            {isFromScannerBarcode
                                                ? t(
                                                      'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg19'
                                                  )
                                                : t(
                                                      'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg3'
                                                  )}
                                        </Msg>
                                    )
                                ) : (
                                    ''
                                )}
                            </SetAddedSuccessDiv>
                            {/* {showNotificationPopup &&
                                Object.keys(barcodeDetails).length !== 0 && (
                                    <NotAbleToReceiveSets
                                        onClose={closeNotificationPopup}
                                        batchNumber={barcodeDetails.batchNumber}
                                        setNumber={barcodeDetails.setNumber}
                                        isManual={false}
                                    />
                                )}{' '} */}
                            <CameraScan ScanditLogo={ScanditLogo} style={{ position: 'relative' }}>
                                {/* Always render scanner visible for Safari camera access */}
                                <ScanditBarcodeScanner
                                        key={`scanner-${scanBarCode}`}
                                        videoFit={BarcodePicker.ObjectFit.COVER}
                                        licenseKey={licenseKey}
                                        engineLocation="https://cdn.jsdelivr.net/npm/scandit-sdk@5.x/build"
                                        preloadBlurryRecognition={true}
                                        onReady={handleScannerReady}
                                        onScan={(e) => {
                                            if (e.barcodes && e.barcodes.length > 0) {
                                                callAPI(e.barcodes[0].data);
                                            }
                                        }}
                                        onScanError={handleScannerError}
                                        playSoundOnScan={true}
                                        accessCamera={cameraActive}
                                        scanSettings={getScanSettings()}
                                        targetScanningFPS={30}
                                        id="video"
                                        preloadEngine={true}
                                        preloadCameras={true}
                                        paused={!cameraActive}
                                        laserArea={isFromScannerBarcode
                                            ? SCAN_AREA
                                            : {
                                                  x: 0,
                                                  y: 0.23,
                                                  width: 1,
                                                  height: winWidth > 1024 ? 0.3 : 0.23,
                                              }}
                                          cameraSettings={{
                                            resolutionPreference: 'full-hd',
                                            focusMode: 'continuous',
                                        }}

                                        video
                                    />
                                
                                {/* Overlay loader - positioned above scanner during initialization */}
                                {(!scannerReady || !cameraActive || !videoReady) && (
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '6px',
                                        zIndex: 1000
                                    }}>
                                    </div>
                                )}
                                
                                {scannerReady && cameraActive && videoReady && (
                                    <MessageContainer
                                        className="msg-container"
                                        RedBg={
                                            smShow &&
                                            (!isBarcodeLoading ||
                                                !isScannerBarcodeLoading) &&
                                            (invalidBarcode ||
                                                errorMessage === 'DuplicateScan' ||
                                                showNotAbleToReceiveSetsErrorMessage ||
                                                dChainCrossPlantStatus)
                                        }
                                    >
                                    {smShow ? (
                                        <ShowMsg>
                                            {invalidBarcode &&
                                                errorMessage !=
                                                    'DuplicatedScan' && (
                                                    <>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent:
                                                                    'center',
                                                            }}
                                                        >
                                                            <img
                                                                src={
                                                                    AlertCircleOutline
                                                                }
                                                                height={'16px'}
                                                                width={'16px'}
                                                                style={{
                                                                    margin: '5px 6px 0 0',
                                                                }}
                                                            />
                                                            <Msg>
                                                                {t(
                                                                    'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg4'
                                                                )}
                                                            </Msg>
                                                        </div>
                                                        <Msg isRegular={true}>
                                                            {isFromScannerBarcode
                                                                ? t(
                                                                      'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg18'
                                                                  )
                                                                : t(
                                                                      'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg5'
                                                                  )}
                                                        </Msg>
                                                    </>
                                                )}

                                            {dChainCrossPlantStatus &&
                                                errorMessage !=
                                                    'DuplicatedScan' && (
                                                    <>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent:
                                                                    'center',
                                                            }}
                                                        >
                                                            <img
                                                                src={
                                                                    AlertCircleOutline
                                                                }
                                                                height={'16px'}
                                                                width={'16px'}
                                                                style={{
                                                                    margin: '5px 6px 0 0',
                                                                }}
                                                            />
                                                            <Msg>
                                                                {isFromScannerBarcode
                                                                    ? t(
                                                                          'common.itemLowerCaseLabel'
                                                                      )
                                                                    : t(
                                                                          'common.setLowerCaseLabel'
                                                                      )}{' '}
                                                                {t(
                                                                    'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg15'
                                                                )}
                                                            </Msg>
                                                        </div>
                                                        {!isFromScannerBarcode ? (
                                                            <Msg
                                                                isRegular={true}
                                                            >
                                                                {isFromScannerBarcode
                                                                    ? t(
                                                                          'common.itemLowerCaseLabel'
                                                                      )
                                                                    : t(
                                                                          'common.setLowerCaseLabel'
                                                                      )}{' '}
                                                                {
                                                                    validatedData?.setNo
                                                                }{' '}
                                                                {t(
                                                                    'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg6'
                                                                )}
                                                            </Msg>
                                                        ) : null}
                                                    </>
                                                )}
                                            {showNotAbleToReceiveSetsErrorMessage ? (
                                                <>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent:
                                                                'center',
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                AlertCircleOutline
                                                            }
                                                            height={'16px'}
                                                            width={'16px'}
                                                            style={{
                                                                margin: '5px 6px 0 0',
                                                            }}
                                                        />
                                                        <Msg>
                                                            {t(
                                                                'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg7'
                                                            )}{' '}
                                                        </Msg>
                                                    </div>
                                                    <Msg isRegular={true}>
                                                        <NotAbleToReceiveSetsErrorMessage />
                                                    </Msg>
                                                </>
                                            ) : null}

                                            {errorMessage === 'DuplicateScan' &&
                                            !invalidBarcode &&
                                            !dChainCrossPlantStatus ? (
                                                <>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent:
                                                                'center',
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                AlertCircleOutline
                                                            }
                                                            height={'16px'}
                                                            width={'16px'}
                                                            style={{
                                                                margin: '5px 6px 0 0',
                                                            }}
                                                        />
                                                        <Msg>
                                                            {t(
                                                                'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg8'
                                                            )}
                                                        </Msg>
                                                    </div>
                                                    <Msg isRegular={true}>
                                                        {t(
                                                            'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg9'
                                                        )}
                                                    </Msg>
                                                </>
                                            ) : null}
                                            {(isBarcodeLoading ||
                                                isScannerBarcodeLoading) &&
                                            errorMessage != 'DuplicateScan' &&
                                            !invalidBarcode &&
                                            !showNotAbleToReceiveSetsErrorMessage &&
                                            !dChainCrossPlantStatus ? (
                                                <>
                                                    <Msg>
                                                        {' '}
                                                        {t(
                                                            'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg10'
                                                        )}
                                                    </Msg>
                                                    <SpinnerDiv>
                                                        <Spinner
                                                            id="receiveSets-scanBardCodePopUp-spinnerDiv-loadingSpinner"
                                                            animation="border"
                                                            variant="primary"
                                                            small
                                                        ></Spinner>
                                                    </SpinnerDiv>
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                            {errorMessage != 'DuplicateScan' &&
                                                !invalidBarcode &&
                                                !showNotAbleToReceiveSetsErrorMessage &&
                                                !dChainCrossPlantStatus &&
                                                counter != 0 &&
                                                (!isBarcodeLoading ||
                                                    !isScannerBarcodeLoading) &&
                                                showSuccessMessage && (
                                                    <TroubleContainer>
                                                        <div className="trouble-container">
                                                            <div className="having-touble-text">
                                                                {t(
                                                                    'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg11'
                                                                )}
                                                            </div>
                                                            <div className="avoid-glare-text">
                                                                {t(
                                                                    'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg16'
                                                                )}
                                                            </div>
                                                        </div>
                                                    </TroubleContainer>
                                                )}
                                        </ShowMsg>
                                    ) : (
                                        <TroubleContainer>
                                            {counter == 0 && (
                                                <>
                                                    <div className="hold-text">
                                                        {t(
                                                            'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg12'
                                                        )}
                                                    </div>
                                                    <TroubleContainer>
                                                        <div className="trouble-container">
                                                            <div className="having-touble-text">
                                                                {t(
                                                                    'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg13'
                                                                )}
                                                            </div>
                                                            <div className="avoid-glare-text">
                                                                {t(
                                                                    'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg16'
                                                                )}
                                                            </div>
                                                        </div>
                                                    </TroubleContainer>
                                                </>
                                            )}

                                            {/* <Trouble /> */}
                                        </TroubleContainer>
                                    )}
                                </MessageContainer>
                                )}
                            </CameraScan>
                        </div>
                    </Content>
                    <ActionButton>
                        <Button
                        id={'receiveSets-ScanBardCodePopUp-close-button'}
                            show={true}
                            //secondary={true}
                            variant={ButtonStyles?.secondary}
                            backgroundColor={'unset'}
                            width={isLanguageChanged ? '150px' : '130px'}
                            // fontSize={'15px'}
                            clicked={closeTab}
                            WhiteSpace={'nowrap'}
                        >
                            {t(
                                'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg17'
                            )}
                        </Button>
                    </ActionButton>
                </Container>
            </ModalDialog>
        </>
    );
};

export default ScanBardCodePopUp;